import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RoleService } from '../services/role.service';
import { Role } from '../models/role.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'role',
  templateUrl: '../views/admin/role.html',
  providers: [RoleService]
})
export class RoleComponent{
  public title: string;
  public roles: Role[];
  public submitRoleModel: Role;
  public message: any;
  public mode: string;
  public checkValue:number;
  public wait:boolean;
  public customerPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private roleService: RoleService,
    public sharedVariables: VariableService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitRoleModel = new Role(0,'',false,false,false,false,false);
      this.checkValue = 1;
      this.wait = true;
      this.customerPrivilege = null;
  }

/*  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    if(this.sharedVariables.validSession())
      this.getAllRoles();
    else
      this.title = "Error, Sesión no iniciada";
  }*/
  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.customerPrivilege == 1){
                                    this.getAllRoles();
                                    this.wait=false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllRoles()
  {
    this.roleService.getRoles().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{

          for(let i = 0; i<result.data.length;i++){
            for(var key in result.data[i])
            {
              if(result.data[i][key] == 0)
                result.data[i][key] = false;
              else if(result.data[i][key] == 1)
              result.data[i][key] = true;
            }
        }
          this.roles = result.data;
          console.log(this.roles);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.submitRoleModel = this.serializer(this.submitRoleModel);
      this.saveRole();
    }else{
      this.submitRoleModel = this.serializer(this.submitRoleModel);
      this.updateRole();
    }

    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllRoles();
                      this.submitRoleModel = new Role(0,'',false,false,false,false,false);
                    },this.sharedVariables.timeToLoad);


    console.log("mode",this.mode);
  }

  saveRole()
  {
    this.roleService.addRole(this.submitRoleModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }


  editRole(pRole: Role)
  {
    this.mode = "submit-update";
    this.submitRoleModel = Object.assign({}, pRole);
  }

  updateRole()
  {
      let id = this.submitRoleModel.ID;
      console.log("objeto update ",this.submitRoleModel);
      this.roleService.updateRole(id,this.submitRoleModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }



  deleteRole(id: number)
  {
    this.roleService.deleteRole(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllRoles();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  serializer(object: any)
  {
    for(let key in object)
    {
      if(object[key] == false)
      {
        object[key] = 0;
      }
      else if(object[key] == true)
      {
        object[key] = 1;
      }
    }
    return object;
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.customerPrivilege = response.data[0].Customer;
            console.log("Privilegios del usuario",this.customerPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/role.component.ts